import invariant from "invariant";

const cleanValue = (value, type) => {
    if (value === "") {
        value = null;
    }
    if (value != null) {
        if (type === "DATE") {
            invariant(moment.isMoment(value), `${type} fields only accept Moment values, not '${value}'.`);
            // midnight
            value.startOf("day");
        } else if (type === "TIME") {
            invariant(moment.isMoment(value), `${type} fields only accept Moment values, not '${value}'.`);
            // time after epoch
            value.year(1970);
            value.month(0);
            value.date(1);
        } else if (type === "DATETIME") {
            invariant(moment.isMoment(value), `${type} fields only accept Moment values, not '${value}'.`);
        } else if (type === "INTEGER") {
            // for loosey-goosey AS scriptlets
            value = Math.round(value);
        } else if (type === "DECIMAL") {
            if (typeof value !== "string") {
                value = value.toString();
            }
        }
    }
    return value;
};

export default cleanValue;



// WEBPACK FOOTER //
// ./app/data/util/cleanValue.js